/** Legacy catalog columns are stored as "-" when only dynamic attributes are used. */
function isPlaceholder(s) {
  const t = String(s ?? "").trim();
  return t === "" || t === "-";
}

/**
 * Short "middle" segment for dropdowns: legacy "type, unit" or dynamic attributes summary.
 */
export function productVariantSummary(product) {
  if (!product) return "";
  const u = product.unit;
  const ty = product.type;
  if (!isPlaceholder(ty) || !isPlaceholder(u)) {
    return `${ty}, ${u}`;
  }
  return formatExtrasBrief(product.extraAttributes);
}

/**
 * One-line extra attributes: "batch: x · unit: box" (uses API field keys).
 */
export function formatExtrasBrief(extraAttributes) {
  if (!extraAttributes || typeof extraAttributes !== "object") return "";
  const parts = Object.entries(extraAttributes)
    .filter(([, v]) => v != null && String(v).trim() !== "")
    .map(([k, v]) => `${k}: ${v}`);
  return parts.join(" · ");
}

/**
 * Full label for product picker rows: name - variant - price context.
 */
export function productPickerLabel(product) {
  if (!product) return "";
  const mid = productVariantSummary(product);
  const price =
    typeof product.unitPrice === "number"
      ? product.unitPrice.toFixed(2)
      : String(product.unitPrice ?? "");
  if (mid) {
    return `${product.name} - ${mid} - ${price} ETB`;
  }
  return `${product.name} - ${price} ETB`;
}

/**
 * Value stored on order lines when the catalog product has no explicit SKU.
 * Prefer human-readable text from dynamic attributes over "(-, -)".
 */
export function productToOrderLineSku(product) {
  if (!product) return "";
  if (product.sku && String(product.sku).trim()) return String(product.sku).trim();
  const u = product.unit;
  const ty = product.type;
  if (!isPlaceholder(ty) || !isPlaceholder(u)) {
    return `${product.name} (${ty}, ${u})`;
  }
  const extras = formatExtrasBrief(product.extraAttributes);
  if (extras) {
    return `${product.name} (${extras})`;
  }
  return product.name;
}
